import {Button} from '@gravity-ui/uikit';
import React, {Component, ErrorInfo, ReactNode} from 'react';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {hasError: false};
  }

  static getDerivedStateFromError(error: Error): State {
    return {hasError: true, error};
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Ошибка загрузки компонента:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        this.props.fallback || (
          <div
            style={{
              padding: '2rem',
              textAlign: 'center',
              borderRadius: '8px',
              margin: '1rem',
            }}>
            <h3 style={{color: '#d63031', margin: '0 0 1rem 0'}}>Ошибка загрузки страницы</h3>
            <p style={{color: '#636e72', margin: '0 0 1rem 0'}}>Произошла ошибка. Попробуйте обновить страницу.</p>
            <Button onClick={() => window.location.reload()}>Обновить страницу</Button>
          </div>
        )
      );
    }

    return this.props.children;
  }
}

export const withErrorBoundary = <P extends object>(
  Component: React.ComponentType<P>,
  fallback?: ReactNode,
): React.FC<P> => {
  return (props: P) => (
    <ErrorBoundary fallback={fallback}>
      <Component {...props} />
    </ErrorBoundary>
  );
};
